import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import styles from './FacilityUnitsEditor.scss';

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  configDetails: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

const columnNames = {
  configID: 'Config ID',
};

const getColumnKeys = (columns) => {
  const keys = Object.keys(columns);
  keys.sort(); // eslint-disable-line no-unused-expressions
  return keys;
};

const RentalAppEditor = ({ configDetails, onChange }) => {
  const handleChange = ({ target }) => {
    onChange({
      type: 'configDetails',
      key: target.name,
      value: target.value,
    });
  };

  const columnKeys = getColumnKeys(configDetails);

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <span className={styles.title}>Rental App Configurations</span>
      </div>
      {columnKeys.map(key => (
        <Form.Group
          className={styles.inputGroup}
          controlId={key}
          // validationState={validateChange({ type: 'configDetails', key })}
        >
          <Form.Label className={styles.label}>
            {columnNames[key]}
          </Form.Label>
          <Form.Control
            name={key}
            onChange={handleChange}
            value={configDetails[key]}
          />
          <Form.Control.Feedback />
        </Form.Group>
      ))}
    </div>
  );
};

RentalAppEditor.propTypes = propTypes;

export default RentalAppEditor;
